module.exports = __webpack_public_path__ + "img/jin_bg.c8941f63.png";